import Component from '@glimmer/component'
import { action } from '@ember/object'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { Sortable } from 'teacher-ui-client/components/th/sortable'
import { formatDate } from 'ember-intl'
import { t } from 'ember-intl'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import type { SpellingProgressEventsReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  eventsData: SpellingProgressEventsReportData['events']
}

interface Signature {
  Args: Args
  Element: Element
}

export class RexSpellingProgressEventsDetailed extends Component<Signature> {
  @queryParam('reporting/ui-scope/rex/dashboard/student/spelling-lesson-progress/index') sort!: string

  @action
  updateSort(newSort: string) {
    this.sort = newSort
  }

  <template>
    <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
      <thead>
        <tr class="bg-oceany-blue-50 divide-x divide-white">
          <Sortable class="w-40" @sort={{this.sort}} @sortKey="created_at" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="lesson_name" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.lessonName"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="lesson_module" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.levelLesson"}}
          </Sortable>
          <Sortable
            @sort={{this.sort}}
            @sortKey="achievement_level"
            @updateSort={{this.updateSort}}
            @tooltip={{t
              "components.reporting.tables.readingEggspress.dashboardStudent.headers.achievementLevelTooltip"
              htmlSafe=true
            }}
          >
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.achievementLevel"}}
          </Sortable>
          <Sortable @sort={{this.sort}} @sortKey="score" @updateSort={{this.updateSort}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.score"}}
          </Sortable>
        </tr>
      </thead>
      <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
        {{#each @eventsData as |event|}}
          <tr>
            <td class="p-3">{{formatDate event.created_at day="2-digit" month="short" year="numeric"}}</td>
            <td class="p-3">
              {{t
                "components.reporting.tables.readingEggspress.dashboardStudent.lessonEventRow"
                number=event.lesson
                name=event.lesson_name
              }}
            </td>
            <td class="p-3">{{event.lesson_module}}</td>
            <td class="p-3">
              {{t
                "components.reporting.tables.readingEggspress.dashboardStudent.spellingAchievementLevel"
                achievementLevel=event.achievement_level
              }}
            </td>
            <td class="p-3">{{event.score}}%</td>
          </tr>
        {{else}}
          <tr>
            <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
              {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </template>
}

export default RexSpellingProgressEventsDetailed
